export default __webpack_public_path__ + "static/media/WhatsApp.7accabd7.svg";